import {
  bindEvents,
  closeSecondaryMenuMobile,
  fadeInPrimaryMenuItems,
  fadeInSecondaryMenuDesktop,
  fadeOutSecondaryMenuItems,
  initiateFadeOutSecondaryMenuDesktop,
  openSecondaryMenuMobile,
  resetPrimaryMobileMenuItems
} from "./chunk.DXJPX6AD.js";
import {
  isMobile
} from "./chunk.YDQDJZUC.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.HRTOWRLV.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Animatable
} from "./chunk.LXK2U27H.js";
import {
  debounce,
  getEventElement
} from "./chunk.PSCGDE4H.js";
import {
  D,
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  n,
  r as r3
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-menu/jb-menu.scss?inline
var jb_menu_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.mobile-menu .secondary-wrapper .submenu-header .tag {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

.mobile-menu .secondary-wrapper .submenu-header .title {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  background-color: #141e55;
  display: block;
  height: 100%;
  height: calc(100vh - 60px);
  transform-origin: top center;
  width: 100%;
}
@media (min-width: 600px) {
  :host {
    height: calc(100vh - 90px);
  }
}
@media (min-width: 1281px) {
  :host {
    height: calc(100vh - 100px);
  }
}

jb-secondary-menu-list:focus,
jb-menu-item:focus {
  box-shadow: none;
  outline: none;
}

.desktop-menu {
  --menu-padding-top: 70px;
  height: 100%;
  overflow: hidden;
  padding-top: var(--menu-padding-top);
  transition: transform 0.5s ease-out, padding-top 0.2s linear;
  width: 100%;
  z-index: 201;
}
.desktop-menu div {
  display: flex;
  height: 100%;
  padding-left: 6.955vw;
}
@media (min-width: 1437px) and (hover: hover) {
  .desktop-menu div {
    padding-left: calc((100vw - var(--theme-row-max-width, 1436px)) / 2);
  }
}
.desktop-menu div .primary-wrapper,
.desktop-menu div .secondary-wrapper {
  box-sizing: border-box;
  flex-basis: 33.3333333333%;
  max-width: 33.3333333333%;
  padding: 0 20px;
  width: 33.3333333333%;
  margin-left: 16.6666666667%;
}
.desktop-menu div .primary-wrapper {
  flex-basis: calc(86.09vw * 0.3333);
  margin-left: calc(86.09vw * 0.1667);
  max-width: calc(86.09vw * 0.3333);
  overflow-y: auto;
  width: calc(86.09vw * 0.3333);
}
.desktop-menu div .primary-wrapper jb-menu-item,
.desktop-menu div .primary-wrapper jb-service-navigation {
  opacity: 0;
}
.desktop-menu div .primary-wrapper::-webkit-scrollbar {
  background-color: #f1f2f2;
  width: 5px;
}
.desktop-menu div .primary-wrapper::-webkit-scrollbar-track {
  background-clip: content-box;
  background-color: #141e55;
}
.desktop-menu div .primary-wrapper::-webkit-scrollbar-thumb {
  background-color: #f1f2f2;
  border-radius: 4px;
  width: 180px;
}
@media (min-width: 1437px) and (hover: hover) {
  .desktop-menu div .primary-wrapper {
    flex-basis: calc(var(--theme-row-max-width, 1436px) * 0.3333);
    margin-left: calc(var(--theme-row-max-width, 1436px) * 0.1667);
    max-width: calc(var(--theme-row-max-width, 1436px) * 0.3333);
    width: calc(var(--theme-row-max-width, 1436px) * 0.3333);
  }
}
.desktop-menu div .primary-wrapper.hidden {
  opacity: 0;
  z-index: -1;
}
.desktop-menu div .primary-wrapper jb-service-navigation {
  display: none;
}
.desktop-menu div .primary-wrapper .primary {
  flex-basis: 100%;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(1) {
  transition: opacity 0.5s ease-in-out 0s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(2) {
  transition: opacity 0.5s ease-in-out 0.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(3) {
  transition: opacity 0.5s ease-in-out 0.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(4) {
  transition: opacity 0.5s ease-in-out 0.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(5) {
  transition: opacity 0.5s ease-in-out 0.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(6) {
  transition: opacity 0.5s ease-in-out 1s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(7) {
  transition: opacity 0.5s ease-in-out 1.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(8) {
  transition: opacity 0.5s ease-in-out 1.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(9) {
  transition: opacity 0.5s ease-in-out 1.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(10) {
  transition: opacity 0.5s ease-in-out 1.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(11) {
  transition: opacity 0.5s ease-in-out 2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(12) {
  transition: opacity 0.5s ease-in-out 2.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(13) {
  transition: opacity 0.5s ease-in-out 2.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(14) {
  transition: opacity 0.5s ease-in-out 2.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(15) {
  transition: opacity 0.5s ease-in-out 2.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(16) {
  transition: opacity 0.5s ease-in-out 3s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(17) {
  transition: opacity 0.5s ease-in-out 3.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(18) {
  transition: opacity 0.5s ease-in-out 3.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(19) {
  transition: opacity 0.5s ease-in-out 3.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(20) {
  transition: opacity 0.5s ease-in-out 3.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden {
  opacity: 0;
  z-index: -1;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(1) {
  transition: opacity 0.5s ease-in-out 1s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(2) {
  transition: opacity 0.5s ease-in-out 0.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(3) {
  transition: opacity 0.5s ease-in-out 0.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(4) {
  transition: opacity 0.5s ease-in-out 0.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(5) {
  transition: opacity 0.5s ease-in-out 0.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(6) {
  transition: opacity 0.5s ease-in-out 0s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(7) {
  transition: opacity 0.5s ease-in-out -0.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(8) {
  transition: opacity 0.5s ease-in-out -0.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(9) {
  transition: opacity 0.5s ease-in-out -0.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(10) {
  transition: opacity 0.5s ease-in-out -0.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(11) {
  transition: opacity 0.5s ease-in-out -1s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(12) {
  transition: opacity 0.5s ease-in-out -1.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(13) {
  transition: opacity 0.5s ease-in-out -1.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(14) {
  transition: opacity 0.5s ease-in-out -1.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(15) {
  transition: opacity 0.5s ease-in-out -1.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(16) {
  transition: opacity 0.5s ease-in-out -2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(17) {
  transition: opacity 0.5s ease-in-out -2.2s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(18) {
  transition: opacity 0.5s ease-in-out -2.4s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(19) {
  transition: opacity 0.5s ease-in-out -2.6s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item.hidden:nth-child(20) {
  transition: opacity 0.5s ease-in-out -2.8s;
}
.desktop-menu div .primary-wrapper .primary jb-menu-item:nth-child(1) {
  --padding-top: 10px;
}
@media (min-width: 1281px) {
  .desktop-menu div .primary-wrapper .primary jb-menu-item {
    --padding-top: 25px;
  }
}
.desktop-menu div .secondary-wrapper {
  margin-left: 0%;
  flex-grow: 1;
  max-width: none;
  opacity: 0;
  overflow: hidden auto;
  -webkit-overflow-scrolling: touch;
  padding-right: 0;
  position: relative;
}
.desktop-menu div .secondary-wrapper::-webkit-scrollbar {
  background-color: #f1f2f2;
  width: 5px;
}
.desktop-menu div .secondary-wrapper::-webkit-scrollbar-track {
  background-clip: content-box;
  background-color: #141e55;
}
.desktop-menu div .secondary-wrapper::-webkit-scrollbar-thumb {
  background-color: #f1f2f2;
  border-radius: 4px;
  width: 180px;
}
.desktop-menu div .secondary-wrapper .submenu-header.hidden {
  display: none;
}
.desktop-menu div .secondary-wrapper .secondary {
  transition: opacity 0.4s;
  z-index: -1;
}
.desktop-menu div .secondary-wrapper .secondary .desktop-menu__item.hidden {
  transition: opacity 0.5s ease-in-out, height 0s 0.5s;
}
.desktop-menu div .secondary-wrapper .secondary .desktop-menu__item:last-child {
  padding-bottom: 150px;
}
.desktop-menu a {
  display: inline-block;
}
.desktop-menu jb-secondary-menu-list {
  opacity: 0;
  transition: opacity 0.4s ease-in-out;
}
.desktop-menu jb-secondary-menu-list.active {
  opacity: 1;
  z-index: 99;
}

.mobile-menu {
  overflow: hidden;
  padding-bottom: 112px;
  padding-top: 30px;
  transition: transform 0.5s ease-out, padding-top 0.2s linear;
  width: 100%;
  z-index: 201;
}
@media (min-width: 600px) {
  .mobile-menu {
    padding-top: 50px;
  }
}
@media (min-width: 960px) {
  .mobile-menu {
    padding-top: 70px;
  }
}
.mobile-menu .wrapper {
  display: flex;
  padding-left: 0;
}
.mobile-menu jb-service-navigation {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  min-block-size: 40px;
  opacity: 1;
  transition: opacity 0.35s ease-in-out 0.1s;
}
.mobile-menu jb-service-navigation.hidden {
  opacity: 0;
}
.mobile-menu .primary-wrapper {
  position: relative;
}
.mobile-menu .primary-wrapper jb-menu-item,
.mobile-menu .primary-wrapper jb-service-navigation {
  opacity: 0;
}
.mobile-menu .primary-wrapper jb-service-navigation-item {
  position: relative;
}
.mobile-menu .primary-wrapper.hidden {
  opacity: 0;
  z-index: -1;
}
.mobile-menu .primary-wrapper jb-menu-item {
  --padding-bottom: 16px;
  --padding-top: 25px;
}
.mobile-menu .primary-wrapper jb-menu-item:nth-child(1) {
  --padding-top: 0;
}
@media (min-width: 600px) {
  .mobile-menu .primary-wrapper jb-menu-item {
    --padding-top: 21px;
  }
}
@media (hover: none) and (min-width: 600px) {
  .mobile-menu .primary-wrapper jb-menu-item {
    --padding-top: 24px;
  }
}
.mobile-menu .primary-wrapper jb-menu-item.hidden {
  opacity: 0;
  z-index: -1;
}
.mobile-menu .primary-wrapper .primary {
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  width: calc(100% - 2 * var(--theme-row-small-margin, 6.68%));
  display: block;
  margin-left: var(--theme-row-small-margin, 6.68%);
  margin-right: auto;
}
@media (min-width: 600px) and (max-width: 959px) {
  .mobile-menu .primary-wrapper .primary {
    width: calc(100% - 2 * 8.35%);
  }
}
@media (min-width: 1437px) {
  .mobile-menu .primary-wrapper .primary {
    max-width: var(--theme-row-max-width, 1436px);
  }
  .mobile-menu .primary-wrapper .primary:not(.filtered-list) {
    width: 100%;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1436px) {
  .mobile-menu .primary-wrapper .primary {
    margin: 0 6.955%;
    max-width: calc(100% - 6.955% - 6.955%);
  }
}
@media (min-width: 600px) {
  .mobile-menu .primary-wrapper .primary {
    margin-left: 30vw;
    width: 40vw;
  }
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(1) {
  transition: opacity 0.5s ease-in-out 0s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(2) {
  transition: opacity 0.5s ease-in-out 0.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(3) {
  transition: opacity 0.5s ease-in-out 0.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(4) {
  transition: opacity 0.5s ease-in-out 0.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(5) {
  transition: opacity 0.5s ease-in-out 0.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(6) {
  transition: opacity 0.5s ease-in-out 1s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(7) {
  transition: opacity 0.5s ease-in-out 1.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(8) {
  transition: opacity 0.5s ease-in-out 1.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(9) {
  transition: opacity 0.5s ease-in-out 1.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(10) {
  transition: opacity 0.5s ease-in-out 1.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(11) {
  transition: opacity 0.5s ease-in-out 2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(12) {
  transition: opacity 0.5s ease-in-out 2.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(13) {
  transition: opacity 0.5s ease-in-out 2.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(14) {
  transition: opacity 0.5s ease-in-out 2.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(15) {
  transition: opacity 0.5s ease-in-out 2.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(16) {
  transition: opacity 0.5s ease-in-out 3s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(17) {
  transition: opacity 0.5s ease-in-out 3.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(18) {
  transition: opacity 0.5s ease-in-out 3.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(19) {
  transition: opacity 0.5s ease-in-out 3.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item:nth-child(20) {
  transition: opacity 0.5s ease-in-out 3.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(1) {
  transition: opacity 0.5s ease-in-out 1s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(2) {
  transition: opacity 0.5s ease-in-out 0.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(3) {
  transition: opacity 0.5s ease-in-out 0.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(4) {
  transition: opacity 0.5s ease-in-out 0.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(5) {
  transition: opacity 0.5s ease-in-out 0.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(6) {
  transition: opacity 0.5s ease-in-out 0s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(7) {
  transition: opacity 0.5s ease-in-out -0.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(8) {
  transition: opacity 0.5s ease-in-out -0.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(9) {
  transition: opacity 0.5s ease-in-out -0.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(10) {
  transition: opacity 0.5s ease-in-out -0.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(11) {
  transition: opacity 0.5s ease-in-out -1s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(12) {
  transition: opacity 0.5s ease-in-out -1.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(13) {
  transition: opacity 0.5s ease-in-out -1.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(14) {
  transition: opacity 0.5s ease-in-out -1.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(15) {
  transition: opacity 0.5s ease-in-out -1.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(16) {
  transition: opacity 0.5s ease-in-out -2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(17) {
  transition: opacity 0.5s ease-in-out -2.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(18) {
  transition: opacity 0.5s ease-in-out -2.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(19) {
  transition: opacity 0.5s ease-in-out -2.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.hidden:nth-child(20) {
  transition: opacity 0.5s ease-in-out -2.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(1) {
  transition: opacity 0.5s ease-in-out 0s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(2) {
  transition: opacity 0.5s ease-in-out 0.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(3) {
  transition: opacity 0.5s ease-in-out 0.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(4) {
  transition: opacity 0.5s ease-in-out 0.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(5) {
  transition: opacity 0.5s ease-in-out 0.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(6) {
  transition: opacity 0.5s ease-in-out 1s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(7) {
  transition: opacity 0.5s ease-in-out 1.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(8) {
  transition: opacity 0.5s ease-in-out 1.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(9) {
  transition: opacity 0.5s ease-in-out 1.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(10) {
  transition: opacity 0.5s ease-in-out 1.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(11) {
  transition: opacity 0.5s ease-in-out 2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(12) {
  transition: opacity 0.5s ease-in-out 2.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(13) {
  transition: opacity 0.5s ease-in-out 2.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(14) {
  transition: opacity 0.5s ease-in-out 2.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(15) {
  transition: opacity 0.5s ease-in-out 2.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(16) {
  transition: opacity 0.5s ease-in-out 3s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(17) {
  transition: opacity 0.5s ease-in-out 3.2s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(18) {
  transition: opacity 0.5s ease-in-out 3.4s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(19) {
  transition: opacity 0.5s ease-in-out 3.6s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(20) {
  transition: opacity 0.5s ease-in-out 3.8s;
}
.mobile-menu .primary-wrapper .primary.initial-animations jb-menu-item.secondary:nth-child(21) {
  transition: opacity 0.5s ease-in-out 4s;
}
.mobile-menu .primary-wrapper,
.mobile-menu .secondary-wrapper {
  overflow: hidden auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}
.mobile-menu .primary-wrapper::-webkit-scrollbar,
.mobile-menu .secondary-wrapper::-webkit-scrollbar {
  background-color: #f1f2f2;
  width: 5px;
}
.mobile-menu .primary-wrapper::-webkit-scrollbar-track,
.mobile-menu .secondary-wrapper::-webkit-scrollbar-track {
  background-clip: content-box;
  background-color: #141e55;
}
.mobile-menu .primary-wrapper::-webkit-scrollbar-thumb,
.mobile-menu .secondary-wrapper::-webkit-scrollbar-thumb {
  background-color: #f1f2f2;
  border-radius: 4px;
  width: 180px;
}
.mobile-menu .secondary-wrapper {
  left: 0;
  opacity: 0;
  padding-top: 16px;
  pointer-events: none;
  position: absolute;
  right: 0;
  z-index: -1;
}
.mobile-menu .secondary-wrapper jb-button-back {
  cursor: pointer;
  display: block;
  margin-bottom: 20px;
  opacity: 0;
  transform: translateX(20px);
  transition: opacity 0.35s ease-in, transform 0.35s ease-in-out;
  z-index: 10;
}
.mobile-menu .secondary-wrapper.active {
  height: calc(100vh - 90px);
  opacity: 1;
  pointer-events: all;
  z-index: 1;
}
@media (min-width: 600px) {
  .mobile-menu .secondary-wrapper.active {
    height: calc(100vh - 140px);
  }
}
@media (min-width: 960px) {
  .mobile-menu .secondary-wrapper.active {
    height: calc(100vh - 160px);
  }
}
.mobile-menu .secondary-wrapper.active jb-button-back {
  opacity: 1;
  transform: translateX(0);
}
.mobile-menu .secondary-wrapper.fade-out {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}
.mobile-menu .secondary-wrapper .submenu-header {
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  width: calc(100% - 2 * var(--theme-row-small-margin, 6.68%));
  display: block;
  margin-bottom: 26px;
}
@media (min-width: 600px) and (max-width: 959px) {
  .mobile-menu .secondary-wrapper .submenu-header {
    width: calc(100% - 2 * 8.35%);
  }
}
@media (min-width: 1437px) {
  .mobile-menu .secondary-wrapper .submenu-header {
    max-width: var(--theme-row-max-width, 1436px);
  }
  .mobile-menu .secondary-wrapper .submenu-header:not(.filtered-list) {
    width: 100%;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1436px) {
  .mobile-menu .secondary-wrapper .submenu-header {
    margin: 0 6.955%;
    max-width: calc(100% - 6.955% - 6.955%);
  }
}
@media (min-width: 600px) {
  .mobile-menu .secondary-wrapper .submenu-header {
    margin-bottom: 40px;
    margin-left: 30vw;
    width: 40vw;
  }
}
.mobile-menu .secondary-wrapper .submenu-header .title {
  font-size: 26px;
  font-size: 1.625rem;
  line-height: 35px;
  line-height: 2.1875rem;
  color: #fff;
}
.mobile-menu .secondary-wrapper .submenu-header .tag {
  font-size: 11px;
  font-size: 0.6875rem;
  line-height: 16px;
  line-height: 1rem;
  letter-spacing: 1px;
  letter-spacing: 0.0625rem;
  border-left: none;
  color: #fff;
  text-transform: uppercase;
}
.mobile-menu .secondary-wrapper .submenu-header .tag .no-value {
  display: none;
}
.mobile-menu .secondary-wrapper jb-secondary-menu-list {
  max-height: 0;
}
.mobile-menu .secondary-wrapper jb-secondary-menu-list.active {
  display: unset;
  max-height: 200vh;
}
.mobile-menu .secondary-wrapper jb-menu-item.span {
  font-size: 21px;
  font-size: 1.3125rem;
}
.mobile-menu .secondary-wrapper jb-menu-item:first-of-type {
  padding-top: 0;
}`;

// src/components/jb-menu/jb-menu.ts
var JbMenu = class extends Initiable(Animatable(r2)) {
  constructor() {
    super(...arguments);
    this._isMobileMenu = false;
    this._primaryIndex = 0;
    this._secondaryIndex = 0;
  }
  firstUpdated() {
    this._isMobileMenu = isMobile();
    bindEvents(this.renderRoot);
    if (this.active) fadeInPrimaryMenuItems(this.renderRoot, this.renderRoot.querySelector(".primary-wrapper"));
    window.addEventListener(
      "resize",
      debounce(() => {
        this._isMobileMenu = isMobile();
        bindEvents(this.renderRoot);
        this.dispatchEvent(new CustomEvent("jbMenuFullFadeOut"));
        const isSecondaryMenuActive = this.renderRoot.querySelector(".secondary-wrapper.active");
        if (isSecondaryMenuActive) {
          closeSecondaryMenuMobile(this.renderRoot);
        }
      }, 100)
    );
  }
  hideMenu() {
    initiateFadeOutSecondaryMenuDesktop(
      this.shadowRoot,
      this.shadowRoot.querySelector(".primary-wrapper .active")
    );
  }
  loadSubmenu(submenu) {
    fadeInSecondaryMenuDesktop(this.renderRoot, submenu);
  }
  async reveal() {
    await super.reveal();
    if (this._isMobileMenu && this.renderRoot.querySelector(".secondary-wrapper.active")) {
      const secondaryMenuLists = this.renderRoot.querySelectorAll("jb-secondary-menu-list");
      const activeSecondaryMenuName = this.items[this._primaryIndex].submenu;
      const activeSecondaryMenuList = this.renderRoot.querySelector(`[data-belongs="${activeSecondaryMenuName}"]`);
      setTimeout(() => {
        this.renderRoot.querySelector(".secondary-wrapper.active")?.style.removeProperty("display");
      }, 400);
      setTimeout(() => {
        secondaryMenuLists.forEach((secondaryMenuList) => {
          secondaryMenuList.classList.remove("active");
        });
        activeSecondaryMenuList?.classList.add("active");
        activeSecondaryMenuList?.shadowRoot.querySelectorAll("jb-menu-item").forEach((menuItem) => {
          menuItem.classList.remove("hidden");
        });
      }, 200);
    }
  }
  _getLetterIndex(searchArray, letter, startIndex = 0) {
    for (let index = startIndex; index < searchArray.length; index += 1) {
      const node = Array.from(searchArray)[index];
      if (node.text.toLowerCase().startsWith(letter.toLowerCase())) {
        return index;
      }
    }
    if (startIndex !== 0) {
      for (let index = 0; index < startIndex; index += 1) {
        const node = Array.from(searchArray)[index];
        if (node.text.toLowerCase().startsWith(letter.toLowerCase())) {
          return index;
        }
      }
    }
    return -1;
  }
  _handleKeyboardEventPrimary(evt) {
    if (this._isMobileMenu) {
      this._handleKeyboardEventPrimaryMobile(evt);
      return true;
    }
    if (evt.shiftKey && evt.code === "Tab") {
      return true;
    }
    const menuNodes = this.shadowRoot.querySelectorAll(
      "jb-menu-item"
    );
    switch (evt.code) {
      case "ArrowUp":
        this._primaryIndex -= 1;
        if (this._primaryIndex < 0) {
          this._primaryIndex = menuNodes.length - 1;
        }
        this._secondaryIndex = 0;
        fadeInSecondaryMenuDesktop(this.renderRoot, menuNodes[this._primaryIndex].submenu);
        menuNodes[this._primaryIndex].focus();
        break;
      case "ArrowDown":
        this._primaryIndex += 1;
        if (this._primaryIndex >= menuNodes.length) {
          this._primaryIndex = 0;
        }
        this._secondaryIndex = 0;
        fadeInSecondaryMenuDesktop(this.renderRoot, menuNodes[this._primaryIndex].submenu);
        menuNodes[this._primaryIndex].focus();
        break;
      case "ArrowRight":
      case "Tab":
        evt.preventDefault();
        const selectedSecondaryMenu = this.renderRoot.querySelector(".secondary-wrapper")?.querySelector(".active");
        if (selectedSecondaryMenu) {
          selectedSecondaryMenu.focus();
        } else {
          if (evt.code === "Tab") {
            evt.target.blur();
            const firstServiceNavElement = document.querySelector(
              "jb-navigation jb-service-navigation jb-service-navigation-item:nth-of-type(2)"
            );
            firstServiceNavElement.focus();
          }
        }
        break;
      case "Home":
        this._primaryIndex = 0;
        fadeInSecondaryMenuDesktop(this.renderRoot, menuNodes[this._primaryIndex].submenu);
        menuNodes[this._primaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "End":
        this._primaryIndex = menuNodes.length - 1;
        fadeInSecondaryMenuDesktop(this.renderRoot, menuNodes[this._primaryIndex].submenu);
        menuNodes[this._primaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "Enter":
      case "Space":
        break;
      default:
        if (this._isValidKeyStroke(evt.key)) {
          if (this._getLetterIndex(menuNodes, evt.key) === -1) return true;
          this._primaryIndex = this._getLetterIndex(menuNodes, evt.key, this._primaryIndex + 1);
          menuNodes[this._primaryIndex].focus();
          this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
          fadeInSecondaryMenuDesktop(this.renderRoot, menuNodes[this._primaryIndex].submenu);
        }
        break;
    }
    return true;
  }
  _handleKeyboardEventPrimaryMobile(evt) {
    const menuNodes = this.shadowRoot.querySelectorAll(
      "jb-menu-item"
    );
    switch (evt.code) {
      case "Tab":
        evt.preventDefault();
        if (evt.shiftKey) {
          document.querySelector("jb-navigation")?.shadowRoot.querySelector('.top-left-navigation [role="button"]')?.focus();
          break;
        }
        this.renderRoot.querySelector("jb-service-navigation-item").shadowRoot.querySelector("a")?.focus();
        break;
      case "ArrowDown":
        this._primaryIndex += 1;
        if (this._primaryIndex >= this.items.length) {
          this._primaryIndex = 0;
        }
        menuNodes[this._primaryIndex].focus();
        break;
      case "ArrowUp":
        this._primaryIndex -= 1;
        if (this._primaryIndex < 0) {
          this._primaryIndex = this.items.length - 1;
        }
        menuNodes[this._primaryIndex].focus();
        break;
      case "Enter":
      case "Space":
      case "ArrowRight":
        if (evt.code === "Space" || evt.code === "ArrowRight") {
          if (menuNodes[this._primaryIndex].submenu) {
            openSecondaryMenuMobile(this.renderRoot, menuNodes[this._primaryIndex].submenu);
          } else {
            break;
          }
        }
        setTimeout(() => {
          this.renderRoot.querySelector("jb-secondary-menu-list.active")?.focus();
        }, 950);
        break;
      case "Home":
        this._primaryIndex = 0;
        menuNodes[this._primaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "End":
        this._primaryIndex = this.items.length - 1;
        menuNodes[this._primaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      default:
        if (this._isValidKeyStroke(evt.key)) {
          if (this._getLetterIndex(menuNodes, evt.key) === -1) return true;
          this._primaryIndex = this._getLetterIndex(menuNodes, evt.key, this._primaryIndex + 1);
          menuNodes[this._primaryIndex].focus();
          this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
          fadeInSecondaryMenuDesktop(this.renderRoot, menuNodes[this._primaryIndex].submenu);
        }
        break;
    }
    return true;
  }
  _handleKeyboardEventSecondary(evt) {
    if (this._isMobileMenu) {
      this._handleKeyboardEventSecondaryMobile(evt);
      return true;
    }
    const menuNodes = this.shadowRoot.querySelector("jb-secondary-menu-list.active").shadowRoot.querySelectorAll("jb-menu-item");
    let keyCode = evt.code;
    if (evt.shiftKey && evt.code === "Tab") {
      evt.preventDefault();
      keyCode = "ArrowLeft";
    }
    switch (keyCode) {
      case "ArrowLeft":
      case "Escape":
        evt.stopPropagation();
        this.renderRoot.querySelector(".active, .focused")?.focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "ArrowDown":
        this._secondaryIndex += 1;
        if (this._secondaryIndex >= menuNodes.length) {
          this._secondaryIndex = 0;
        }
        menuNodes[this._secondaryIndex].focus();
        break;
      case "ArrowUp":
        this._secondaryIndex -= 1;
        if (this._secondaryIndex < 0) {
          this._secondaryIndex = menuNodes.length - 1;
        }
        menuNodes[this._secondaryIndex].focus();
        break;
      case "Home":
        this._secondaryIndex = 0;
        menuNodes[this._secondaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "End":
        this._secondaryIndex = menuNodes.length - 1;
        menuNodes[this._secondaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "Tab":
        evt.target.blur();
        const firstServiceNavElement = document.querySelector(
          "jb-navigation jb-service-navigation jb-service-navigation-item:nth-of-type(2)"
        );
        firstServiceNavElement.focus();
        break;
      default:
        if (this._isValidKeyStroke(evt.key)) {
          if (this._getLetterIndex(menuNodes, evt.key) === -1) return true;
          this._secondaryIndex = this._getLetterIndex(menuNodes, evt.key, this._secondaryIndex + 1);
          menuNodes[this._secondaryIndex].focus();
          this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        }
        break;
    }
    return true;
  }
  _handleKeyboardEventSecondaryMobile(evt) {
    const menuNodes = this.shadowRoot.querySelector("jb-secondary-menu-list.active").shadowRoot.querySelectorAll("jb-menu-item");
    const currentSubMenu = this.items[this._primaryIndex].submenu;
    let keyCode = evt.code;
    if (evt.code === "Tab" && evt.shiftKey) {
      keyCode = "Shift+Tab";
    }
    switch (keyCode) {
      case "Tab":
        evt.preventDefault();
        fadeOutSecondaryMenuItems(this.renderRoot.querySelector("jb-secondary-menu-list.active"));
        closeSecondaryMenuMobile(this.renderRoot);
        resetPrimaryMobileMenuItems(this.renderRoot, currentSubMenu);
        fadeInPrimaryMenuItems(this.renderRoot, this.renderRoot.querySelector(".primary-wrapper"));
        document.querySelector("jb-navigation")?.shadowRoot.querySelector('.top-left-navigation [role="button"]')?.focus();
        break;
      case "ArrowDown":
        this._secondaryIndex += 1;
        if (this._secondaryIndex >= menuNodes.length) {
          this._secondaryIndex = 0;
        }
        menuNodes[this._secondaryIndex].focus();
        break;
      case "ArrowUp":
        this._secondaryIndex -= 1;
        if (this._secondaryIndex < -1) {
          this._secondaryIndex = menuNodes.length - 1;
        } else if (this._secondaryIndex === -1) {
          this.renderRoot.querySelector("jb-button-back").focus();
          this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
          break;
        }
        menuNodes[this._secondaryIndex]?.focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "Escape":
      case "ArrowLeft":
      case "Shift+Tab":
        evt.stopPropagation();
        evt.preventDefault();
        this._secondaryIndex = 0;
        fadeOutSecondaryMenuItems(this.renderRoot.querySelector("jb-secondary-menu-list.active"));
        closeSecondaryMenuMobile(this.renderRoot);
        resetPrimaryMobileMenuItems(this.renderRoot, currentSubMenu);
        fadeInPrimaryMenuItems(this.renderRoot, this.renderRoot.querySelector(".primary-wrapper"));
        this.renderRoot.querySelectorAll("jb-menu-item")[this._primaryIndex]?.focus();
        break;
      case "Enter":
      case "Space":
        evt.target.click();
        if (evt.target.tagName === "JB-BUTTON-BACK") {
          this._secondaryIndex = 0;
          setTimeout(() => {
            resetPrimaryMobileMenuItems(this.renderRoot, currentSubMenu);
            this.renderRoot.querySelectorAll("jb-menu-item")[this._primaryIndex]?.focus();
          }, 150);
        }
        break;
      case "Home":
        evt.preventDefault();
        this._secondaryIndex = 0;
        menuNodes[this._secondaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "End":
        evt.preventDefault();
        this._secondaryIndex = menuNodes.length - 1;
        menuNodes[this._secondaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      default:
        if (this._isValidKeyStroke(evt.key)) {
          if (this._isValidKeyStroke(evt.key)) {
            if (this._getLetterIndex(menuNodes, evt.key) === -1) return true;
            this._secondaryIndex = this._getLetterIndex(menuNodes, evt.key, this._secondaryIndex + 1);
            menuNodes[this._secondaryIndex].focus();
            this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
          }
        }
        break;
    }
    return true;
  }
  _isValidKeyStroke(key) {
    return key.match(/^[A-z]$/);
  }
  _sendTrackingClick(texts, url, e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "header",
      interaction_effect: url ? "navigation" : "open",
      interaction_element: texts[texts.length - 1],
      interaction_result: url ?? "overlay",
      interaction_text: `hamburger__${texts.join("__")}`,
      interaction_type: "click"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  _trackMenu(evt) {
    evt.stopPropagation();
    const menuItem = getEventElement(evt, "JB-MENU-ITEM");
    const hasSubmenus = this.submenus?.some((e) => e.parent === menuItem.submenu);
    if (this._isMobileMenu && hasSubmenus) {
      return;
    }
    this._sendTrackingClick([menuItem.text.replace(/\s+/g, "-").toLowerCase()], menuItem.link.href, evt);
  }
  _trackServiceNavigation(evt) {
    const serviceNavigationItem = getEventElement(evt, "JB-SERVICE-NAVIGATION-ITEM");
    const serviceNavigationText = serviceNavigationItem.text ?? serviceNavigationItem.trackingLabel ?? serviceNavigationItem.textContent ?? serviceNavigationItem.children[0].textContent;
    const serviceNavigationItemUrl = serviceNavigationItem.link?.data?.action ? void 0 : serviceNavigationItem.link?.href;
    this._sendTrackingClick([serviceNavigationText.replace(/\s+/g, "-").toLowerCase()], serviceNavigationItemUrl, evt);
  }
  _trackSubMenu(evt) {
    evt.stopPropagation();
    const secondaryMenuList = getEventElement(evt, "JB-SECONDARY-MENU-LIST");
    const menuItem = getEventElement(evt, "JB-MENU-ITEM");
    const subMenuItemText = menuItem.text.replace(/\s+/g, "-").toLowerCase();
    const menuItemText = this.items.find((item) => item.submenu === secondaryMenuList.dataset.belongs).text.replace(/\s+/g, "-").toLowerCase();
    this._sendTrackingClick([menuItemText, subMenuItemText], menuItem.link.href, evt);
  }
  render() {
    return ke`<nav
      class="${Rt({
      "mobile-menu": this._isMobileMenu,
      "desktop-menu": !this._isMobileMenu
    })}"
    >
      <div class="wrapper">
        <div class="primary-wrapper">
          <ul
            class="${Rt({
      "initial-animations": this._isMobileMenu,
      primary: true
    })}"
            @keydown=${this._handleKeyboardEventPrimary}
          >
            ${this.items.map(
      (item, indx) => ke`<jb-menu-item
                  .link=${item.link}
                  .submenu=${item.submenu}
                  .tag=${item.tag}
                  .text=${item.text}
                  data-index=${indx}
                  type="primary"
                  .notTabbable=${this._primaryIndex !== indx}
                  @jb-link:clicked=${this._trackMenu}
                  ?focused=${this._primaryIndex === indx}
                  @mouseenter=${() => {
        this._primaryIndex = indx;
        this._secondaryIndex = 0;
      }}
                  @focusin=${(evt) => {
        this._primaryIndex = indx;
        this._secondaryIndex = 0;
        evt.target.dispatchEvent(new MouseEvent("mouseenter", { bubbles: true, composed: true }));
      }}
                  @focusout=${(evt) => {
        evt.target.dispatchEvent(new MouseEvent("mouseleave", { bubbles: true, composed: true }));
      }}
                ></jb-menu-item>`
    )}
          </ul>
          ${this.serviceNavigationItems && ke`
            <jb-service-navigation class="${Rt({
      hidden: !this.active
    })}">
              ${this.serviceNavigationItems.map(
      (item) => ke`<jb-service-navigation-item
                    .link=${item.link}
                    .icon=${item.icon}
                    .trackingLabel=${item.trackingLabel}
                    @jb-link:clicked=${this._trackServiceNavigation}
                    >${item.text}</jb-service-navigation-item
                  >`
    )}</slot>
            </jb-service-navigation>
          `}
        </div>

        ${this.submenus && ke`
          <div
            class="secondary-wrapper"
            @keydown=${this._handleKeyboardEventSecondary}
          >
            <div
              class="${Rt({
      hidden: !this._isMobileMenu,
      "submenu-header": true
    })}"
            >
              <jb-button-back
                role="button"
                .tabIndex=${-1}
                isWhite
                .text=${this.backLabel}
                @focusout=${() => {
      this.renderRoot.querySelector("jb-secondary-menu-list.active")?.shadowRoot.querySelector("jb-menu-item")?.focus();
    }}
              ></jb-button-back>
              <p class="title"></p>
              <p class="tag"></p>
            </div>

            ${this.submenus.map(
      (submenu) => ke`<jb-secondary-menu-list
                  data-belongs="${submenu.parent}"
                  .menuItems=${submenu.subitems}
                  .staticItem=${this._isMobileMenu ? submenu.staticItem : D}
                  .tabIndex=${-1}
                  .activeIndex=${this._secondaryIndex}
                  @jb-link:clicked=${this._trackSubMenu}
                ></jb-secondary-menu-list>`
    )}
          </div>
        `}
      </div>
    </nav>`;
  }
};
JbMenu.styles = r(jb_menu_default);
JbMenu.shadowRootOptions = { ...r2.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Boolean })
], JbMenu.prototype, "active", 2);
__decorateClass([
  n()
], JbMenu.prototype, "backLabel", 2);
__decorateClass([
  n({ type: Array })
], JbMenu.prototype, "items", 2);
__decorateClass([
  n({ type: Array })
], JbMenu.prototype, "serviceNavigationItems", 2);
__decorateClass([
  n({ type: Array })
], JbMenu.prototype, "submenus", 2);
__decorateClass([
  r3()
], JbMenu.prototype, "_isMobileMenu", 2);
__decorateClass([
  r3()
], JbMenu.prototype, "_primaryIndex", 2);
__decorateClass([
  r3()
], JbMenu.prototype, "_secondaryIndex", 2);
JbMenu = __decorateClass([
  customElement("jb-menu")
], JbMenu);

export {
  JbMenu
};
